import PropTypes from 'prop-types';
import React from 'react';
import { Button, Icon } from '@unite-us/ui';
function FormMenuOptions(_ref) {
  var editMode = _ref.editMode,
    isFetching = _ref.isFetching,
    isSaving = _ref.isSaving,
    handleOnDecline = _ref.handleOnDecline,
    handleOnCancel = _ref.handleOnCancel,
    handleOnSubmitDraft = _ref.handleOnSubmitDraft,
    handleOnSubmitComplete = _ref.handleOnSubmitComplete,
    screeningConsent = _ref.screeningConsent,
    disabledOnSubmit = _ref.disabledOnSubmit,
    disableDraftButton = _ref.disableDraftButton;
  var labelIcon = function labelIcon() {
    return screeningConsent ? 'Complete Screening' : 'Decline Screening';
  };
  function IconComponent() {
    return screeningConsent ? /*#__PURE__*/React.createElement(Icon, {
      icon: "V2CheckCircle",
      className: "fill-current"
    }) : /*#__PURE__*/React.createElement(Icon, {
      icon: "IconCrossCircle"
    });
  }
  return editMode && !isFetching && /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between ml-one mr-one mb-two"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cancel-btn",
    className: "form-cancel-button",
    label: "Cancel",
    onClick: handleOnCancel,
    outline: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-nowrap"
  }, screeningConsent && /*#__PURE__*/React.createElement(Button, {
    id: "save-draft-btn",
    className: "ml-one font-semibold",
    label: "Save as Draft",
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      icon: "V2Save",
      class: "fill-current"
    }),
    onClick: handleOnSubmitDraft,
    type: "submit",
    secondary: true,
    disabled: disableDraftButton
  }), /*#__PURE__*/React.createElement(Button, {
    id: "save-complete-btn",
    disabled: disabledOnSubmit,
    className: "ml-one font-semibold",
    label: labelIcon(),
    iconLeft: IconComponent(),
    onClick: screeningConsent ? handleOnSubmitComplete : handleOnDecline,
    type: "submit",
    primary: true
  })));
}
FormMenuOptions.propTypes = {
  disableDraftButton: PropTypes.bool,
  disabledOnSubmit: PropTypes.bool
};
export default FormMenuOptions;
//# sourceMappingURL=index.js.map